// TipSeen — 「困りごとのコツ」カードの既読を端末の localStorage に記録する。
//
// 方針 (docs/_wip/aa-default-and-trouble-tips-2026-10-27.md §2「回数」): 1 端末 1 回。
// どちらのボタンで閉じても既読。storage 不可は「毎回未読」(= その入室中は 1 回だけ出る
// 前提で、呼び出し側が memory 側でも二重表示を防ぐ)。流儀は helpButtonSeen.ts と同じ。

export const tipSeenKey = (tipId: string): string => `oekaki:tip-seen:${tipId}`;

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export interface TipSeenStore {
  hasSeen(tipId: string): boolean;
  markSeen(tipId: string): void;
}

const probeBrowserStorage = (): StorageLike | null => {
  try {
    const ls = globalThis.localStorage;
    if (!ls) return null;
    const sentinel = 'oekaki:tip-seen__probe__';
    ls.setItem(sentinel, '1');
    const got = ls.getItem(sentinel);
    ls.removeItem(sentinel);
    return got === '1' ? ls : null;
  } catch {
    return null;
  }
};

export interface CreateTipSeenStoreOptions {
  /** 既定は localStorage を probe。`null` で no-op (常に未読) を強制。 */
  storage?: StorageLike | null;
}

export const createTipSeenStore = (opts: CreateTipSeenStoreOptions = {}): TipSeenStore => {
  const explicit = opts.storage;
  const storage = explicit === null ? null : (explicit ?? probeBrowserStorage());
  return {
    hasSeen(tipId) {
      if (storage === null) return false;
      try {
        return storage.getItem(tipSeenKey(tipId)) !== null;
      } catch {
        return false;
      }
    },
    markSeen(tipId) {
      if (storage === null) return;
      try {
        storage.setItem(tipSeenKey(tipId), '1');
      } catch {
        // 出し直しになるだけで害はない。
      }
    },
  };
};
